(function($){
    /**
     * Manually set the min-height of a full-height element with attribute data-ct-fullheight, 
     * because the window height adjusts itself in mobile because of the varying height/appearance 
     * of the browser's own toolbar
     */
    $(window).on('load resize sticky.zf.unstuckfrom:top sticky.zf.unstuckfrom:bottom sticky.zf.stuckto:top sticky.zf.stuckto:bottom', function(){
        if('innerHeight' in window){
            $('[data-ct-fullheight]').css({
                'min-height': window.innerHeight + 'px'
            });
        }
    });

}(jQuery));